import AnticipoVinculacion from './AnticipoVinculacion'

const AnticipoAgenteAduana = props => (
  <AnticipoVinculacion
    {...props}
    type={props.type || 'egreso'}
    title='Anticipo Agente de Aduana'
    slug='anticipo-agente-aduana'
    counterpartyLabel='Agente Aduana'
    amountLabel='Monto Anticipo'
    classification='1-1-6-8 Anticipo Agente de Aduana'
  />
)

export default AnticipoAgenteAduana
